import "./Privacy.css";
import Header from "./Header";
import Footer from "./Footer";
import { useState } from "react";
import { BsTypeH1 } from "react-icons/bs";
import SEO from "./SeoHelmet";
import metaConfig from "./SeoComponent";
import { useLocation } from "react-router-dom";

function PrivacyPolicyHrms() {
  const location = useLocation();
  const meta = metaConfig.privacypolicy;
  const [submenuOpen, setSubmenuOpen] = useState(false);

  return (
    <div>
      <SEO {...meta} />

      <div className="container-fluid position-relative p-0">
        <div className="w-100 me-3 top_head">
          <div className="top_head align-items-center"></div>
        </div>
        <Header />
      </div>

      <div className="container-fluid Privacy bg-breadcrumb">
        <div
          className="container text-center py-5"
          style={{ maxWidth: "9000px" }}
        >
          <ol
            className="breadcrumb d-flex justify-content-center mb-0 wow fadeInDown"
            data-wow-delay="0.3s"
          ></ol>
          <h4
            className="text-white display-6 mb-4 wow fadeInDown"
            data-wow-delay="0.1s"
          >
            HRMS Attendance Application Privacy Policy
          </h4>
        </div>
      </div>

      <div className="container-fluid innercontain privacyinner about overflow-hidden py-5">
        <div className="container">
          <div className="row g-5">
            <div
              className="col-xl-9 mt-5 m-auto wow fadeInRight"
              data-wow-delay="0.2s"
            >
              <div className="about-item text-center">
                <h1
                  className="text-white display-3 mb-4 wow fadeInDown"
                  data-wow-delay="0.1s"
                >
                  Kovai Tech HRMS Privacy Policy
                </h1>
                <p className="text-white text-center">
                  Last Updated: April 25, 2025
                </p>
              </div>

              <div className="row mt-5 goals_rules privacy g-4 justify-content-center">
                <div
                  className="col-lg-10 col-xl-10 wow fadeInUp"
                  data-wow-delay="0.2s"
                >
                  <h3 className="mb-4 text-white text-animation">
                    1. Introduction
                  </h3>
                  <p className="text-white">
                    Welcome to the Kovai Tech India Group HRMS Attendance
                    Application ("App"). This Privacy Policy explains how we
                    collect, use, disclose, and safeguard your information when
                    you use our mobile application.
                  </p>
                  <p className="text-white">
                    We are committed to protecting your personal information and
                    your right to privacy. If you have any questions about this
                    Privacy Policy, please contact us at [info@ktig.org.in].
                  </p>
                </div>
              </div>

              <div className="row mt-0 goals_rules privacy justify-content-center">
                <div
                  className="col-lg-10 col-xl-10 wow fadeInUp"
                  data-wow-delay="0.2s"
                >
                  <h3 className="mb-4 text-white text-animation">
                    2. Personal Data We Collect
                  </h3>
                  <p className="text-white">
                    Our HRMS Attendance App collects the following types of
                    personal data:
                  </p>
                  <h4 className="text-white mt-3">
                    2.1. User Profile Information
                  </h4>
                  <ul className="text-white">
                    <li>Full name</li>
                    <li>Employee ID</li>
                    <li>Email address</li>
                    <li>Department/team information</li>
                    <li>Profile picture</li>
                    <li>Contact information</li>
                  </ul>

                  <h4 className="text-white mt-3">2.2. Attendance Data</h4>
                  <ul className="text-white">
                    <li>Clock-in and clock-out times</li>
                    <li>
                      Facial photographs captured during punch-in and punch-out
                      processes
                    </li>
                    <li>Geolocation data at the time of check-in/check-out</li>
                    <li>Work hours and attendance patterns</li>
                  </ul>

                  <h4 className="text-white mt-3">
                    2.3. Leave Management Data
                  </h4>
                  <ul className="text-white">
                    <li>Leave requests and history</li>
                    <li>Approval workflows</li>
                  </ul>

                  <h4 className="text-white mt-3">2.4. Technical Data</h4>
                  <ul className="text-white">
                    <li>Log data and analytics</li>
                  </ul>
                </div>
              </div>

              <div className="row mt-0 goals_rules privacy justify-content-center">
                <div
                  className="col-lg-10 col-xl-10 wow fadeInUp"
                  data-wow-delay="0.2s"
                >
                  <h3 className="mb-4 text-white text-animation">
                    3. Purpose of Data Collection
                  </h3>
                  <p className="text-white">
                    We collect and process your personal data for the following
                    purposes:
                  </p>
                  <h4 className="text-white mt-3">3.1. Core Functionality</h4>
                  <ul className="text-white">
                    <li>
                      To verify your identity during the attendance process
                    </li>
                    <li>To record accurate attendance data</li>
                    <li>
                      To prevent time fraud through facial recognition and
                      location verification
                    </li>
                    <li>To process and manage leave requests</li>
                    <li>
                      To generate attendance reports for payroll and compliance
                      purposes
                    </li>
                  </ul>

                  <h4 className="text-white mt-3">
                    3.2. Improvement and Maintenance
                  </h4>
                  <ul className="text-white">
                    <li>To analyze app usage and improve user experience</li>
                    <li>To identify and fix technical issues</li>
                    <li>To develop new features based on user needs</li>
                    <li>
                      To ensure system security and prevent unauthorized access
                    </li>
                  </ul>

                  <h4 className="text-white mt-3">
                    3.3. Compliance and Reporting
                  </h4>
                  <ul className="text-white">
                    <li>
                      To comply with applicable employment laws and regulations
                    </li>
                    <li>To generate required compliance reports</li>
                    <li>To maintain accurate employee attendance records</li>
                    <li>
                      To provide evidence of attendance in case of disputes
                    </li>
                  </ul>
                </div>
              </div>

              <div className="row mt-0 goals_rules privacy justify-content-center">
                <div
                  className="col-lg-10 col-xl-10 wow fadeInUp"
                  data-wow-delay="0.2s"
                >
                  <h3 className="mb-4 text-white text-animation">
                    4. Data Sharing and Disclosure
                  </h3>
                  <p className="text-white">
                    We may share your personal information with the following
                    categories of recipients:
                  </p>
                  <h4 className="text-white mt-3">4.1. Internal Recipients</h4>
                  <ul className="text-white">
                    <li>
                      HR department personnel responsible for attendance
                      management
                    </li>
                    <li>Direct supervisors and authorized managers</li>
                    <li>Payroll processing staff</li>
                    <li>System administrators</li>
                  </ul>

                  <h4 className="text-white mt-3">
                    4.2. Third-Party Service Providers
                  </h4>
                  <ul className="text-white">
                    <li>Cloud storage providers</li>
                    <li>Analytics service providers</li>
                    <li>Technical support services</li>
                    <li>Security monitoring services</li>
                  </ul>

                  <h4 className="text-white mt-3">4.3. Legal Requirements</h4>
                  <ul className="text-white">
                    <li>Government authorities when required by law</li>
                    <li>Law enforcement agencies with valid legal requests</li>
                    <li>Courts and legal counsel in case of disputes</li>
                    <li>Regulatory bodies for compliance purposes</li>
                  </ul>

                  <p className="text-white mt-3">
                    We do not sell, rent, or trade your personal information to
                    third parties for marketing purposes.
                  </p>
                </div>
              </div>

              <div className="row mt-0 goals_rules privacy justify-content-center">
                <div
                  className="col-lg-10 col-xl-10 wow fadeInUp"
                  data-wow-delay="0.2s"
                >
                  <h3 className="mb-4 text-white text-animation">
                    5. User Rights
                  </h3>
                  <p className="text-white">
                    You have the following rights regarding your personal data:
                  </p>
                  <h4 className="text-white mt-3">
                    5.1. Access and Information
                  </h4>
                  <ul className="text-white">
                    <li>Right to access personal data we hold about you</li>
                    <li>Right to know how your data is being processed</li>
                    <li>
                      Right to request clarification about this privacy policy
                    </li>
                  </ul>

                  <h4 className="text-white mt-3">
                    5.2. Correction and Update
                  </h4>
                  <ul className="text-white">
                    <li>Right to request correction of inaccurate data</li>
                    <li>Right to update incomplete information</li>
                    <li>Right to maintain an accurate user profile</li>
                  </ul>

                  <h4 className="text-white mt-3">
                    5.3. Deletion and Restriction
                  </h4>
                  <ul className="text-white">
                    <li>
                      Right to request deletion of your data (subject to legal
                      retention requirements)
                    </li>
                    <li>Right to restrict certain processing activities</li>
                    <li>
                      Right to object to processing in certain circumstances
                    </li>
                  </ul>

                  <h4 className="text-white mt-3">5.4. Data Portability</h4>
                  <ul className="text-white">
                    <li>
                      Right to receive your data in a structured, commonly used
                      format
                    </li>
                    <li>Right to transmit this data to another service</li>
                  </ul>

                  <p className="text-white mt-3">
                    To exercise any of these rights, please contact us at
                    [info@ktig.org.in].
                  </p>
                </div>
              </div>

              <div className="row mt-0 goals_rules privacy justify-content-center">
                <div
                  className="col-lg-10 col-xl-10 wow fadeInUp"
                  data-wow-delay="0.2s"
                >
                  <h3 className="mb-4 text-white text-animation">
                    6. Account and Data Deletion
                  </h3>
                  <p className="text-white">
                    You may request deletion of your account and associated
                    personal data by:
                  </p>
                  <ol className="text-white">
                    <li>Submitting a request to [info@ktig.org.in]</li>
                    <li>
                      Including your full name and employee ID in the request
                    </li>
                    <li>
                      Specifying "Account Deletion Request" in the subject line
                    </li>
                  </ol>

                  <p className="text-white mt-3">
                    Upon receiving your request, we will:
                  </p>
                  <ul className="text-white">
                    <li>
                      Verify your identity to prevent unauthorized deletions
                    </li>
                    <li>Process your deletion request within 30 days</li>
                    <li>Confirm deletion upon completion</li>
                  </ul>

                  <p className="text-white mt-3">
                    Please note that certain information may be retained for
                    legal compliance, such as attendance records required by
                    labor laws, for a period specified by applicable
                    regulations. We will inform you about any such retention
                    requirements upon receiving your deletion request.
                  </p>
                </div>
              </div>

              <div className="row mt-0 goals_rules privacy justify-content-center">
                <div
                  className="col-lg-10 col-xl-10 wow fadeInUp"
                  data-wow-delay="0.2s"
                >
                  <h3 className="mb-4 text-white text-animation">
                    7. Data Security Measures
                  </h3>
                  <p className="text-white">
                    We implement appropriate technical and organizational
                    measures to protect your personal data, including:
                  </p>
                  <ul className="text-white">
                    <li>End-to-end encryption for data transmission</li>
                    <li>Secure storage with industry-standard encryption</li>
                    <li>Access controls and authentication mechanisms</li>
                    <li>
                      Regular security audits and vulnerability assessments
                    </li>
                    <li>Staff training on data protection and security</li>
                    <li>Intrusion detection and prevention systems</li>
                    <li>Secure development practices</li>
                    <li>Regular backup procedures</li>
                    <li>Incident response planning</li>
                  </ul>
                </div>
              </div>

              <div className="row mt-0 goals_rules privacy justify-content-center">
                <div
                  className="col-lg-10 col-xl-10 wow fadeInUp"
                  data-wow-delay="0.2s"
                >
                  <h3 className="mb-4 text-white text-animation">
                    8. Data Retention
                  </h3>
                  <p className="text-white">
                    We retain your personal information for as long as necessary
                    to fulfill the purposes outlined in this Privacy Policy,
                    unless a longer retention period is required by law.
                    Specifically:
                  </p>
                  <ul className="text-white">
                    <li>Active employee data: Throughout employment period</li>
                    <li>
                      Attendance records: Per legal requirements (typically 2-7
                      years depending on jurisdiction)
                    </li>
                    <li>
                      Facial images: Deleted within 60 days after capture unless
                      required for dispute resolution
                    </li>
                    <li>
                      Location data: Retained for 6 months for attendance
                      verification
                    </li>
                    <li>Technical logs: Up to 90 days</li>
                  </ul>
                </div>
              </div>

              <div className="row mt-0 goals_rules privacy justify-content-center">
                <div
                  className="col-lg-10 col-xl-10 wow fadeInUp"
                  data-wow-delay="0.2s"
                >
                  <h3 className="mb-4 text-white text-animation">
                    9. International Data Transfers
                  </h3>
                  <p className="text-white">
                    If we transfer your data across international borders, we
                    ensure appropriate safeguards are in place through:
                  </p>
                  <ul className="text-white">
                    <li>Standard contractual clauses</li>
                    <li>Data processing agreements</li>
                    <li>Compliance with regional data protection laws</li>
                    <li>Transfer impact assessments</li>
                  </ul>
                </div>
              </div>

              <div className="row mt-0 goals_rules privacy justify-content-center">
                <div
                  className="col-lg-10 col-xl-10 wow fadeInUp"
                  data-wow-delay="0.2s"
                >
                  <h3 className="mb-4 text-white text-animation">
                    10. Policy Updates
                  </h3>
                  <p className="text-white">
                    We may update this Privacy Policy from time to time. We will
                    notify you of any changes by:
                  </p>
                  <ul className="text-white">
                    <li>Posting the new Privacy Policy on this page</li>
                    <li>Sending an in-app notification about the changes</li>
                    <li>
                      Updating the "Last Updated" date at the top of this page
                    </li>
                  </ul>
                  <p className="text-white mt-3">
                    We recommend reviewing this Privacy Policy periodically for
                    any changes.
                  </p>
                </div>
              </div>

              <div className="row mt-0 goals_rules privacy justify-content-center">
                <div
                  className="col-lg-10 col-xl-10 wow fadeInUp"
                  data-wow-delay="0.2s"
                >
                  <h3 className="mb-4 text-white text-animation">
                    11. Contact Information
                  </h3>
                  <p className="text-white">
                    If you have questions, concerns, or requests regarding this
                    Privacy Policy or our data practices, please contact us at:
                  </p>
                  <p className="text-white">
                    [KOVAI TECH INDIA GROUP]
                    <br />
                    [No.53-2, 2nd Floor, 3rd Cross, MKP Colony, Ganapathy,
                    Coimbatore - 641 006]
                    <br />
                    [info@ktig.org.in]
                    <br />
                    [6380750897]
                  </p>
                  <p className="text-white">
                    Data Protection Officer: [Mr.Dhinesh-9843185635]
                  </p>
                </div>
              </div>

              <div className="row mt-0 goals_rules privacy justify-content-center">
                <div
                  className="col-lg-10 col-xl-10 wow fadeInUp"
                  data-wow-delay="0.2s"
                >
                  <h3 className="mb-4 text-white text-animation">
                    12. Regulatory Information
                  </h3>
                  <p className="text-white">
                    [KOVAI TECH INDIA GROUP] complies with all applicable data
                    protection regulations including [list applicable laws based
                    on your jurisdiction, such as GDPR, CCPA, etc.].
                  </p>
                  <p className="text-white">
                    You have the right to lodge a complaint with your local data
                    protection authority if you believe your rights have been
                    violated.
                  </p>
                </div>
              </div>

              <div className="row mt-0 goals_rules privacy justify-content-center">
                <div
                  className="col-lg-10 col-xl-10 wow fadeInUp"
                  data-wow-delay="0.2s"
                >
                  <h3 className="mb-4 text-white text-animation">
                    13. Data Retention – Children’s Data
                  </h3>
                  <p className="text-white">
                    This app is intended for use only by individuals aged 18 and
                    above. We do not knowingly collect or retain personal data
                    from anyone under the age of 18.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />

      <a
        href="#"
        className="btn btn-secondary btn-lg-square rounded-circle back-to-top"
      >
        <i className="fa fa-arrow-up"></i>
      </a>
    </div>
  );
}

export default PrivacyPolicyHrms;
